module.exports = __webpack_public_path__ + "img/tengjiaoniurou.08468462.jpg";